import type { AppVersion, VersionStatus } from '@/types'
import { compareVersionDesc } from './platform'

const SIDEBAR_STATUSES = new Set<VersionStatus>([
  'released',
  'reviewing',
  'scheduled',
  'rejected',
  'developing',
])

/**
 * C4 侧栏最多 5 条：固定位（唯一线上版本 / 审核中 / 待上线各 1）
 * + 弹性位（已拒绝、草稿按版本号倒序）。
 */
export function pickSidebarVersions(versions: AppVersion[]): AppVersion[] {
  const eligible = versions
    .filter((v) => SIDEBAR_STATUSES.has(v.status))
    .slice()
    .sort((a, b) => compareVersionDesc(a.version, b.version))

  const picked: AppVersion[] = []
  const used = new Set<string>()

  const takeFirst = (status: VersionStatus) => {
    const hit = eligible.find((v) => v.status === status && !used.has(v.id))
    if (hit) {
      picked.push(hit)
      used.add(hit.id)
    }
  }

  takeFirst('released')
  takeFirst('reviewing')
  takeFirst('scheduled')

  for (const v of eligible) {
    if (picked.length >= 5) break
    if (used.has(v.id)) continue
    if (v.status === 'rejected' || v.status === 'developing') {
      picked.push(v)
      used.add(v.id)
    }
  }

  return picked.sort((a, b) => compareVersionDesc(a.version, b.version))
}
